import React, { FC } from 'react';
import { DialogContentProps } from '../../types';
import { NumberColValue } from '../../../GridV2/types';
import { Row, Col } from '../../../GridV2';

import Action from './Action';

export interface MainActionsProps
  extends Pick<
    DialogContentProps,
    'type' | 'action' | 'action2' | 'action3' | 'dark'
  > {
  totalInnerCols: {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
  };
}

const MainActions: FC<MainActionsProps> = ({
  type = 'm',
  action,
  action2,
  action3,
  dark,
  totalInnerCols,
}) => (
  <Row
    className="flex flex-col-reverse sm:flex-row md:flex-col-reverse lg:flex-row"
    totalCols={totalInnerCols}
  >
    <Col
      xs={totalInnerCols.xs}
      sm={
        type === 'm-form'
          ? totalInnerCols.sm
          : ((totalInnerCols.sm - 2) as NumberColValue)
      }
      md={
        type === 'm-form'
          ? totalInnerCols.md
          : ((totalInnerCols.md - 2) as NumberColValue)
      }
      offset={type === 'm-form' ? 0 : { sm: 1 }}
      className="flex flex-col items-center"
    >
      {action && (
        <Action
          type={type}
          action={action}
          actionType="1"
          dark={dark}
          className={action2 || action3 ? 'mb-24' : ''}
        />
      )}
      {action2 && (
        <Action
          type={type}
          action={action2}
          actionType="2"
          dark={dark}
          className={action3 ? 'mb-32' : ''}
        />
      )}
      {action3 && (
        <Action type={type} action={action3} actionType="3" dark={dark} />
      )}
    </Col>
  </Row>
);

export default MainActions;
